/* eslint-disable no-unused-vars */
//import BidCell from '../cellRenderers/BidCell';
//import CampaignName from '../cellRenderers/CampaignName';
//import { DailyBudget } from '../cellRenderers/DailyBudget';
import { useFacade } from './useFacade';
import { Pagination } from './components/index';
import Loader from 'components/common/loader/Loader';
import * as S from './AgGrid.styled';
import './gridStyle.css';

const rowHeight = 72;
const additionalHeight = 42;
const headerHeight = 32;
const maxHeight = rowHeight * 5 + headerHeight * 2 + additionalHeight;

export const AgGrid2 = ({
  // rowDataResult,
  filteredCamp,
}) => {
  const {
    onGridReady,
    onColumnVisible,
    height,
    onBodyScroll,
    pinnedTopRowData,
    rowData,
    openedRows$,
    horizontalScroll$,
    firstEventContentClassName$,
    firstEventCohortContentClassName$,
    totalRows$,
    colDefs,
    handleSort,
    onModelUpdated,
    gridRef,
    onRowDataUpdated,
    paginationStep,
  } = useFacade(
    rowHeight,
    // rowDataResult,
    headerHeight,
    additionalHeight,
    filteredCamp,
  );

  const onFirstDataRendered = () => {
    //console.log('onFirstDataRendered');
  };

  return (
    <S.GridContainer height={height} maxHeight={maxHeight}>
      <S.GridBox className='ag-theme-quartz'>
        <S.MyGrid
          onRowDataUpdated={onRowDataUpdated}
          onFirstDataRendered={onFirstDataRendered}
          onModelUpdated={onModelUpdated}
          onColumnVisible={onColumnVisible}
          onGridReady={onGridReady}
          pinnedTopRowData={pinnedTopRowData}
          ref={gridRef}
          rowData={rowData}
          columnDefs={colDefs}
          animateRows={true}
          rowHeight={rowHeight}
          headerHeight={headerHeight}
          autoSizeStrategy={autoSizeStrategy}
          multiSortKey={null}
          domLayout='autoHeight'
          //domLayout='normal'
          pagination={true}
          paginationPageSize={openedRows$.value}
          onBodyScroll={onBodyScroll}
          suppressPaginationPanel={true}
          suppressScrollOnNewData={true}
          isShadow={horizontalScroll$.value > 0}
          classNameFirstEventContent={firstEventContentClassName$.value}
          classNameFirstEventCohortContent={firstEventCohortContentClassName$.value}
        />
        <Pagination
          openedRows$={openedRows$}
          gridRef={gridRef}
          totalRows$={totalRows$}
          paginationStep={paginationStep}
        />
      </S.GridBox>
    </S.GridContainer>
  );
};

const autoSizeStrategy = {
  type: 'fitGridWidth',
  defaultMinWidth: 100,
  columnLimits: [
    {
      colId: 'countries',
      minWidth: 154,
    },
    { colId: 'impressions', minWidth: 142 },
    { colId: 'video_views', minWidth: 120 },
  ],
};
